import {
  DataGrid,
  DataGridProps,
  GridColDef,
  GridColumnVisibilityModel,
  GridRowsProp,
  GridSortModel,
  GridToolbar,
  GridValidRowModel,
} from "@mui/x-data-grid";
import { enUS, svSE } from "@mui/x-data-grid/locales";
import OptionsButton from "../buttons/OptionsButton";
import { useMemo } from "react";

export interface DefaultDataGridProps
  extends Omit<DataGridProps, "columns" | "rows" | "columnVisibilityModel"> {
  rows: GridRowsProp;
  columns: GridColDef[];
  sortingConfig?: GridSortModel;
  visibleColumns?: GridColumnVisibilityModel;
  rowOptions?: (row: any) => RowOption[];
}
export type RowOption = {
  label: string;
  value: string;
  disabled?: boolean;
  onClick: (row: GridValidRowModel) => void;
};
const DefaultDataGrid = (props: DefaultDataGridProps) => {
  const { rows, columns, sortingConfig, visibleColumns, rowOptions, ...rest } =
    props;

  const locale = localStorage.getItem("selectedLanguage");
  const browserLanguage = navigator.language.split("-")[0];

  const dataGridLocale = useMemo(() => {
    if (locale) {
      return locale === "en" ? enUS : svSE;
    } else {
      return browserLanguage === "en" ? enUS : svSE;
    }
  }, [locale]);

  const enhancedColumns: GridColDef[] = rowOptions
    ? [
        ...columns,
        {
          field: "actions",
          headerName: "",
          align: "right",
          disableColumnMenu: true,
          headerAlign: "right",
          renderCell: (params) => (
            <OptionsButton
              options={rowOptions(params.row).map((action) => {
                return {
                  label: action.label,
                  value: action.value,
                  disabled: action.disabled,
                  onClick: () => action.onClick(params.row.id),
                };
              })}
            />
          ),
        },
      ]
    : columns;

  return (
    <>
      <DataGrid
        columnBufferPx={100}
        initialState={{
          filter: {
            filterModel: {
              items: [],
              quickFilterExcludeHiddenColumns: false,
            },
          },
          sorting: {
            sortModel: sortingConfig,
          },
        }}
        ignoreDiacritics={true}
        disableColumnSelector
        disableDensitySelector
        columnVisibilityModel={visibleColumns}
        columns={enhancedColumns}
        rows={rows}
        slots={{ toolbar: GridToolbar }}
        slotProps={{ toolbar: { showQuickFilter: true } }}
        localeText={
          dataGridLocale.components.MuiDataGrid.defaultProps.localeText
        }
        {...rest}
      />
    </>
  );
};

export default DefaultDataGrid;
